module.exports = __webpack_public_path__ + "assets/media/startup.04634874.mp3";